import { render, staticRenderFns } from "./SedimentStations.vue?vue&type=template&id=0ab25ea2&scoped=true"
import script from "./SedimentStations.vue?vue&type=script&lang=js"
export * from "./SedimentStations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab25ea2",
  null
  
)

export default component.exports